// extracted by mini-css-extract-plugin
module.exports = {"productPerPageWrapper":"ProductsPerPage_productPerPageWrapper__6o3sO"};